import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="12" height="12" viewBox="0 0 12 12" {...props}><path fill="currentColor" d="M0 3h12l-6 7z" /></svg>);